import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="share"
// Provides share functionality for supported social networks (Facebook, X)
export default class extends Controller {
  static values = {
    title: String,
    text: String,
    url: String,
  };

  connect() {
    // Defaults if not provided
    if (!this.hasUrlValue) this.urlValue = window.location.href;
    if (!this.hasTitleValue) this.titleValue = document.title;
  }

  share(event) {
    event.preventDefault();
    const network = event.currentTarget.dataset.network;
    const shareUrl = this.buildShareUrl(network);

    if (!shareUrl) return;

    // Attempt Web Share API first (only for generic share buttons without network, fallback otherwise)
    if (!network && navigator.share) {
      navigator
        .share({
          title: this.titleValue,
          text: this.textValue || this.titleValue,
          url: this.urlValue,
        })
        .catch(() => {
          // user cancelled or not supported - ignore
        });
      return;
    }

    const w = 600;
    const h = 540;
    const left = window.screenX + (window.outerWidth - w) / 2;
    const top = window.screenY + (window.outerHeight - h) / 2.5;

    window.open(
      shareUrl,
      "share-window",
      `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=${h},width=${w},top=${top},left=${left}`
    );
  }

  buildShareUrl(network) {
    const url = encodeURIComponent(this.urlValue);
    const text = encodeURIComponent(this.textValue || this.titleValue);

    switch (network) {
      case "facebook":
        return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
      case "x":
        return `https://twitter.com/intent/tweet?url=${url}&text=${text}`;
      default:
        return null;
    }
  }
}
